//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"FlowDirection",1,0],[0,"Origin",1,0],[0,"PressDirection",1,0]],[[["objects"],"SetProductBodies",{},1,0],[["num_objects"],"GetProductBodies",{R_:{objects:"Body[]"}},0,0],[["strings"],"SetDetails",{},1,0],[["num_strings"],"GetDetails",{R_:{strings:""}},0,0]],[]];
SPLM.Die.LineupBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.LineupBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;